import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-excel/${id}`), {
      responseType: 'arraybuffer',
    });
  },
  async findOnePadres(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-excel/padres/${id}`), {
      responseType: 'arraybuffer',
    });
  },
};
